import React, { useEffect, useRef, useState } from "react";
import { Camera, Trash2 } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

export default function OspiteFoto({ ospite, onChanged }) {
  const [url, setUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  useEffect(() => {
    let obj = null;
    const load = async () => {
      if (!ospite.foto_path) { setUrl(null); return; }
      try { const res = await api.get(`/ospiti/${ospite.id}/foto`, { responseType: "blob" }); obj = URL.createObjectURL(res.data); setUrl(obj); }
      catch { setUrl(null); }
    };
    load();
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [ospite.id, ospite.foto_path]);

  const pick = () => fileRef.current?.click();
  const onFile = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Seleziona un'immagine"); e.target.value = ""; return; }
    setUploading(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      await api.post(`/ospiti/${ospite.id}/foto`, fd);
      toast.success("Foto aggiornata"); onChanged && onChanged();
    } catch { toast.error("Errore caricamento foto"); }
    finally { setUploading(false); e.target.value = ""; }
  };
  const removePhoto = async () => {
    setUploading(true);
    try { await api.delete(`/ospiti/${ospite.id}/foto`); setUrl(null); toast.success("Foto rimossa"); onChanged && onChanged(); }
    catch { toast.error("Errore rimozione foto"); }
    finally { setUploading(false); }
  };

  const initials = `${ospite.nome?.[0] || ""}${ospite.cognome?.[0] || ""}`;
  return (
    <div className="relative h-20 w-20 shrink-0" data-testid="ospite-foto">
      {url
        ? <img src={url} alt={initials} className="h-20 w-20 rounded-2xl object-cover border" data-testid="ospite-foto-img" />
        : <div className="h-20 w-20 rounded-2xl grid place-items-center text-white text-2xl font-bold" style={{ background: "var(--gr-primary)" }}>{initials}</div>}
      <button onClick={pick} disabled={uploading} data-testid="ospite-foto-upload" title="Carica / cambia foto"
        className="absolute -bottom-1.5 -right-1.5 h-7 w-7 rounded-full bg-white border shadow grid place-items-center hover:bg-secondary transition-colors disabled:opacity-50">
        <Camera size={14} />
      </button>
      {url && (
        <button onClick={removePhoto} disabled={uploading} data-testid="ospite-foto-remove" title="Rimuovi foto"
          className="absolute -bottom-1.5 -left-1.5 h-7 w-7 rounded-full bg-white border shadow grid place-items-center hover:bg-destructive/10 transition-colors disabled:opacity-50">
          <Trash2 size={13} className="text-destructive" />
        </button>
      )}
      <input type="file" accept="image/*" ref={fileRef} onChange={onFile} className="hidden" data-testid="ospite-foto-input" />
    </div>
  );
}
